const { sleepUntil, getElement, getElements, formatMoney } = window.BAO.Utils;

class VolumeBoostPricing extends window.BAO.CustomElement() {
  static get requiredAttributes() {
    return [
      "data-price-inc-vat",
      "data-vat-rate",
      "data-translation-get-each",
      "data-translation-inc-vat",
      "data-translation-exc-vat",
    ];
  }

  static selectors = {
    price: ".hulkapps-price",
  };

  setupListeners() {
    super.setupListeners();

    this.handleElementRender(
      this.constructor.selectors.price,
      this.handlePriceElementRender.bind(this),
    );
  }

  async handleElementRender(selector, callback) {
    await sleepUntil(
      () => getElements(selector, { context: this })?.length,
      100,
    );

    return callback();
  }

  handlePriceElementRender() {
    if (this.getAttribute("aria-hidden") === "true") return;

    const priceEls = getElements(this.constructor.selectors.price, {
      context: this,
    });

    priceEls.forEach((priceEl) => {
      const discountText = priceEl.textContent;
      const discountTextLowercased = discountText?.toLowerCase();
      const quantityText = getElement("td", {
        context: priceEl?.closest("tr"),
      })?.textContent;
      if (!discountText || !quantityText) return;

      const quantity = parseInt(
        quantityText.includes("-")
          ? quantityText.split("-")[0]
          : quantityText.replace(/\D/g, ""),
      );

      this.setAttribute(
        "aria-hidden",
        String(quantity === 1 && priceEls?.length === 1),
      );

      let rowType = "fixed-price";

      // When a "(" and the word "each" appear in the string the first value is either a percentage or price discount
      if (
        discountTextLowercased.includes("(") &&
        discountTextLowercased.includes("each")
      ) {
        if (discountTextLowercased.includes("%")) {
          rowType = "percentage-discount";
        } else if (
          discountTextLowercased.includes("£") ||
          discountTextLowercased.includes("€")
        ) {
          rowType = "price-discount";
        }
      } else if (discountTextLowercased.includes("% off")) {
        rowType = "percentage-discount";
      }

      if (rowType === "fixed-price") {
        this.renderFixedPrice(priceEl, discountText);
      }

      if (rowType === "percentage-discount") {
        this.renderPercentageDiscount(priceEl, discountText);
      }

      if (rowType === "price-discount") {
        this.renderPriceDiscount(priceEl, discountText);
      }
    });
  }

  renderFixedPrice(priceEl, discountText) {
    if (!priceEl || !discountText) return;

    const priceIncVat = parseInt(
      discountText.split("(")?.[0]?.replace(/\D/g, ""),
    );
    const priceExcVat = Math.ceil(priceIncVat / this.vatRate);

    priceEl.innerHTML = /* html */ `
      <span class="vb-Pdp_Price vb-Pdp_Price-incVat">${
        this.dataset.translationGetEach
      } ${formatMoney(priceIncVat)} ${this.dataset.translationIncVat}</span>
      <span class="vb-Pdp_Price vb-Pdp_Price-excVat fz-12_140">${
        this.dataset.translationGetEach
      } ${formatMoney(priceExcVat)} ${this.dataset.translationExcVat}</span>
    `;
  }

  renderPercentageDiscount(priceEl, discountText) {
    if (!priceEl || !discountText) return;

    const percentage =
      (100 - parseInt(discountText?.split("%")?.[0]?.replace(/\D/g, ""))) / 100;
    const priceIncVat = Math.ceil(
      parseInt(this.dataset.priceIncVat) * percentage,
    );
    const priceExcVat = Math.ceil(priceIncVat / this.vatRate);

    priceEl.innerHTML = /* html */ `
      <span class="vb-Pdp_Price vb-Pdp_Price-incVat">${
        this.dataset.translationGetEach
      } ${formatMoney(priceIncVat)} ${this.dataset.translationIncVat}</span>
      <span class="vb-Pdp_Price vb-Pdp_Price-excVat fz-12_140">${
        this.dataset.translationGetEach
      } ${formatMoney(priceExcVat)} ${this.dataset.translationExcVat}</span>
    `;
  }

  renderPriceDiscount(priceEl, discountText) {
    if (!priceEl || !discountText) return;

    const discountAmount = parseInt(
      discountText.split("(")?.[0]?.replace(/\D/g, ""),
    );
    const priceIncVat = parseInt(this.dataset.priceIncVat) - discountAmount;
    const priceExcVat = Math.ceil(priceIncVat / this.vatRate);

    priceEl.innerHTML = /* html */ `
      <span class="vb-Pdp_Price vb-Pdp_Price-incVat">${
        this.dataset.translationGetEach
      } ${formatMoney(priceIncVat)} ${this.dataset.translationIncVat}</span>
      <span class="vb-Pdp_Price vb-Pdp_Price-excVat fz-12_140">${
        this.dataset.translationGetEach
      } ${formatMoney(priceExcVat)} ${this.dataset.translationExcVat}</span>
    `;
  }

  get vatRate() {
    return parseFloat(this.dataset.vatRate);
  }
}

if (!window.customElements.get("volume-boost-pricing")) {
  window.customElements.define("volume-boost-pricing", VolumeBoostPricing);
}
